/* unplugin-vue-components disabled */import { render } from "./pixelmodelshow.vue?vue&type=template&id=9c649914&scoped=true"
import script from "./pixelmodelshow.vue?vue&type=script&lang=js"
export * from "./pixelmodelshow.vue?vue&type=script&lang=js"

import "./pixelmodelshow.vue?vue&type=style&index=0&id=9c649914&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c649914"]])

export default __exports__